import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Favorites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: Math.floor(Math.random() * 20),
      nbTab: [
        "51",
        "57",
        "65",
        "85",
        "91",
        "119",
        "133",
        "143",
        "187",
        "209",
        "221",
        "247",
        "253",
        "289",
        "299",
        "323",
        "361",
        "391",
        "437",
        "529",
      ],
      opTab: [
        "17x3",
        "19x3",
        "13x5",
        "17x5",
        "13x7",
        "17x7",
        "19x7",
        "11x13",
        "17x11",
        "11x19",
        "13x17",
        "13x19",
        "23x11",
        "17x17",
        "23x13",
        "19x17",
        "19x19",
        "23x17",
        "23x19",
        "23x23",
      ],
      number1: "",
      number2: "",
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerFavorites = (event) => {
    event.preventDefault();
    var answer = this.state.number1 * this.state.number2;
    var good = this.state.nbTab[this.state.random];
    if (Number(answer) === Number(good)) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.nbTab[this.state.random] +
          " = " +
          this.state.opTab[this.state.random],
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.nbTab[this.state.random] +
          " = " +
          this.state.opTab[this.state.random],
      });
    }
    var rand = Math.floor(Math.random() * 20);
    this.setState({ random: rand, number1: "", number2: ""});
  };

  myChangeNumber1 = (event) => {
    this.setState({ number1: event.target.value });
  };
  myChangeNumber2 = (event) => {
    this.setState({ number2: event.target.value });
  };

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">
              Les 20 nombres préférés des concepteurs
            </h2>
          </div>
        </div>

        <div className="container">
          <p className={this.state.messageColor}>{this.state.message}</p>
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerFavorites}
          >
            <label className="label-exos">
              {this.state.nbTab[this.state.random]} ={" "}
            </label>
            <div className="row" style={{ alignItems: "baseline" }}>
              <input
                className="input-number"
                type="number"
                name="number1"
                value={this.state.number1} 
                onChange={this.myChangeNumber1}
              />
              <p style={{ marginRight: 10, marginLeft: 10 }}>x</p>
              <input
                className="input-number"
                type="number"
                name="number2"
                value={this.state.number2} 
                onChange={this.myChangeNumber2}
              />
            </div>
            <input
              className="validate-button"
              style={{ backgroundColor: "#00cfa4" }}
              type="submit"
              value="Valider"
            />
          </form>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Favorites;
